import {Pipe, PipeTransform} from '@angular/core';
import {clFormatDateTimeUTC} from '@castlabs/ui';

@Pipe({
  name: 'cldate'
})
export class CldatePipe implements PipeTransform {

  transform(date: string | Date): string {
    if (typeof date === 'string') {
      date = new Date(Date.parse(date));
    }
    return clFormatDateTimeUTC(date)
  }
}
